/* eslint-disable @typescript-eslint/no-explicit-any */

export function takeIfNotEmpty<T>(value: Array<T> | undefined): Array<T> | undefined {
  return value?.length ? value : undefined
}

export function takeIfOneOf<T>(value: any | null | undefined, ...valid: T[]): T | undefined {
  return value && valid.includes(value) ? value : undefined
}